import React, { useEffect, useState } from "react";
import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import logo from "../../assets/images/logo.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faUser,
  faShoppingCart,
  faArrowUpRightDots,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Navbar, Container, Dropdown } from "react-bootstrap";
import ButtonComponent from "../ButtonComponent";
import CartsLocationMap from "../CartsLocationMap";
import Swal from "sweetalert2";
import { auth } from "../../firebase";
import OpenSignUpModal, {
  openModalForSignUpUsers,
} from "../../views/AuthModals/SignIn/openSignIn";
import { clearInitialData } from "../../redux/initialDataSlice";
import { getUserInitials } from "../../utility/Utility";
import { clearCustomer } from "../../redux/customerSlice";

const TopNavBar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartItems = useSelector(
    (state: RootState) => state.localCartList.localCartList
  );
  const cartItemCount = cartItems.length;

  const selectedSavedCart = useSelector(
    (state: RootState) => state.cartList.selectedCart
  );

  const userProfileImage = useSelector(
    (state: any) => state.customer?.photoUrl
  );

  const userName = useSelector(
    (state: any) => state.customer?.displayName
  );

  const [expanded, setExpanded] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);

  const [isSignInModalOpen, setIsSignInModalOpen] = useState<boolean>(false);

  const [isMapOpen, setIsMapOpen] = useState(false);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const textTruncater = (
    text: string | undefined | null,
    maxLength: number
  ) => {
    if (!text) return "Cart Location";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleMap = () => {
    setIsMapOpen((prev) => !prev);
  };

  const handleOnlineOrders = () => {
    navigate("/order");
  };

  const handleCartList = () => {
    navigate("/shoppingCart");
  };

  const handleOrderList = () => {
    const newCustomerId = localStorage.getItem("customerId");
    navigate(`/onlineOrders?customerId=${newCustomerId}`);
  };

  const handleLocations = () => {
    toggleMap();
  };

  const handleUserProfile = () => {
    navigate("/profile");
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogOut = () => {
    Swal.fire({
      title: "Are you sure you want to log out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#008000",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log out",
      width: "auto",
      customClass: {
        popup: "swal-responsive",
      },
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        try {
          await signOut(auth);
          localStorage.clear();
          dispatch(clearCustomer());
          navigate("/");
          clearInitialData();
        } catch (error) {
          console.error("Logout failed:", error);
        }
      }
    });
  };
  const pendingOrdersCount = useSelector(
    (state: RootState) => state.orders.pendingOrdersCount
  );
  return (
    <>
      <Navbar
        expand="xl"
        bg="light"
        className="navbar-container p-3 w-100"
        expanded={expanded}
      >
        <Container fluid>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" className="navbarlogoStyles" />
          </Navbar.Brand>
          <div className="d-flex align-items-center mobile-options-icons">
            <div
              className={`position-relative pt-2 me-3 ${screenWidth >= 1200 ? "hide-on-large" : ""
                } ms-auto`}
            >
              <FontAwesomeIcon
                icon={faShoppingCart}
                onClick={handleCartList}
                className="cart-notification-icon"
              />
              {cartItemCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cart-notification-badge">
                  {cartItemCount > 99 ? "99+" : cartItemCount}
                </span>
              )}
            </div>
            <div
              className={`position-relative me-3 me-3 ${screenWidth >= 1200 ? "hide-on-large" : ""
                }
              `}
            >
              <Dropdown>
                <Dropdown.Toggle
                  as="div"
                  id="dropdown-user"
                  className={`user-icon p-2 ${(userProfileImage || userProfileImage === "https://lh3.googleusercontent.com/a/ACg8ocKfWYhQp16pX0WjwmwhPQ0lsXn55u-mAYKJk1xzNs-YgPHVRdU=s96-c") ? 'has-photo p-2' : ''}`}
                >
                  {localStorage.getItem("isUserSignIN") === "true" ? (
                    userProfileImage ? (
                      <img
                        src={userProfileImage}
                        alt="User"
                        className="rounded-circle cursor-pointer"
                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div
                        className="rounded-circle cursor-pointer d-flex align-items-center justify-content-center text-white"
                        style={{
                          width: '30px',
                          height: '30px',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          backgroundColor: 'transparent'
                        }}
                      >
                        {getUserInitials(userName)}
                      </div>
                    )
                  ) : (
                    <FontAwesomeIcon icon={faUser} className="cursor-pointer" />
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  {localStorage.getItem("isUserSignIN") === "true" ? (
                    <Dropdown.Item onClick={handleUserProfile}>
                      User Profile
                    </Dropdown.Item>
                  ) : (
                    <></>
                  )}
                  {localStorage.getItem("isUserSignIN") === "true" ? (
                    <Dropdown.Item onClick={handleLogOut}>
                      Log Out
                    </Dropdown.Item>
                  ) : (
                    <Dropdown.Item
                      onClick={() =>
                        openModalForSignUpUsers(
                          setModalOpen,
                          setIsSignInModalOpen
                        )
                      }
                    >
                      Sign In
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="navbar-toggler"
              onClick={() => setExpanded((prevExpanded) => !prevExpanded)}
            />
          </div>
          <Navbar.Collapse id="responsive-navbar-nav" in={expanded}>
            <div className="w-100 hide-on-small big-contain gap-5">
              <div className="d-flex align-items-center gap-5 ">
                <Link to="/order" className="top-bar-links">
                  <h6>Menu</h6>
                </Link>
                <Link to="/our-promise" className="top-bar-links">
                  <h6>Our Promise</h6>
                </Link>
                <div className="top-bar-links position-relative">
                  <h6 onClick={handleOrderList} className="position-relative">
                    My Orders
                    {pendingOrdersCount > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success cart-notification-badge">
                        {pendingOrdersCount > 99 ? "99+" : pendingOrdersCount}
                      </span>
                    )}
                  </h6>
                </div>
                <Link to="/contact" className="top-bar-links">
                  <h6>Contact</h6>
                </Link>
              </div>
              <div className="d-flex align-items-center gap-3 ">
                <div className="position-relative p-1">
                  <FontAwesomeIcon
                    icon={faShoppingCart}
                    onClick={handleCartList}
                    className="cart-notification-icon"
                  />
                  {cartItemCount > 0 && (
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cart-notification-badge">
                      {cartItemCount > 99 ? "99+" : cartItemCount}
                    </span>
                  )}
                </div>
                <ButtonComponent
                  title="Online Order"
                  onClick={handleOnlineOrders}
                  icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                  backgroundColor="#590B21"
                />
                <ButtonComponent
                  title={
                    selectedSavedCart === null
                      ? "Cart Location"
                      : textTruncater(selectedSavedCart?.name, 15)
                  }
                  onClick={handleLocations}
                  icon={<FontAwesomeIcon icon={faLocationDot} />}
                  backgroundColor="black"
                />
                <Dropdown>
                  <Dropdown.Toggle
                    as="div"
                    id="dropdown-user"
                    className={`user-icon p-2 ${(userProfileImage || userProfileImage === "https://lh3.googleusercontent.com/a/ACg8ocKfWYhQp16pX0WjwmwhPQ0lsXn55u-mAYKJk1xzNs-YgPHVRdU=s96-c") ? 'has-photo p-2' : ''}`}
                  >
                    {localStorage.getItem("isUserSignIN") === "true" ? (
                      userProfileImage ? (
                        <img
                          src={userProfileImage}
                          alt="User"
                          className="rounded-circle cursor-pointer"
                          style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                        />
                      ) : (
                        <div
                          className="rounded-circle cursor-pointer d-flex align-items-center justify-content-center text-white"
                          style={{
                            width: '40px',
                            height: '30px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            backgroundColor: 'transparent'
                          }}
                        >
                          {getUserInitials(userName)}
                        </div>
                      )
                    ) : (
                      <FontAwesomeIcon icon={faUser} className="cursor-pointer" />
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    {localStorage.getItem("isUserSignIN") === "true" ? (
                      <Dropdown.Item onClick={handleUserProfile}>
                        User Profile
                      </Dropdown.Item>
                    ) : (
                      <></>
                    )}
                    {localStorage.getItem("isUserSignIN") === "true" ? (
                      <Dropdown.Item onClick={handleLogOut}>
                        Log Out
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item
                        onClick={() =>
                          openModalForSignUpUsers(
                            setModalOpen,
                            setIsSignInModalOpen
                          )
                        }
                      >
                        Sign In
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <Row className={window.innerWidth >= 1200 ? "hide-on-large" : ""}>
              <Col
                className="d-flex flex-column align-items-start gap-3 top-links-container mt-3"
                xs="12"
              >
                <Link to="/order" className="top-bar-links">
                  <h6>Menu</h6>
                </Link>
                <Link to="/our-promise" className="top-bar-links">
                  <h6>Our Promise</h6>
                </Link>
                <div className="top-bar-links">
                  <h6 onClick={handleOrderList}>My Orders</h6>
                </div>
                <Link to="/contact" className="top-bar-links">
                  <h6>Contact</h6>
                </Link>
                {expanded && (
                  <>
                    <button
                      onClick={handleOnlineOrders}
                      className="d-flex btn btn-danger rounded align-items-center gap-2 px-3 py-2 mobile-online-order-button"
                    >
                      Online Order
                    </button>
                    <button
                      onClick={handleLocations}
                      className="d-flex btn btn-dark rounded align-items-center gap-2 px-3 py-2 mobile-location-button"
                    >
                      <FontAwesomeIcon icon={faLocationDot} />
                      {selectedSavedCart === null
                        ? "Cart Location"
                        : selectedSavedCart?.name || ""}
                    </button>
                  </>
                )}
              </Col>
            </Row>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <OpenSignUpModal
        toggleModal={toggleModal}
        isModalOpen={isModalOpen}
        isSignInModalOpen={isSignInModalOpen}
        setModalOpen={setModalOpen}
        setIsSignInModalOpen={setIsSignInModalOpen}
      />

      <CartsLocationMap isMapOpen={isMapOpen} toggleMap={toggleMap} />
    </>
  );
};

export default TopNavBar;
